import React, {useState} from 'react';
import styled from "styled-components";
import {Button, Icon, Modal} from "react-materialize";
import ConciliateTransactionsModal from "../../Shared/Modals/ConciliateTransactions/ConciliateTransactionsModal.react";

const StyledButton = styled(Button)`
  background-color: #07bb9c;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 2rem;
  
  i {
    padding-right: .5rem;
  }
`

const ConciliateTransactionsButton = () => {
  const [open, setOpen] = useState(false);

  const handleToggle = (modalState = true) => {
    setOpen(modalState);
  }

  return (
    <>
      <StyledButton onClick={handleToggle}><Icon>add</Icon>Add Transactions</StyledButton>
      <ConciliateTransactionsModal handleToggle={handleToggle} open={open} />
    </>
  )
}

export default ConciliateTransactionsButton;